import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const WithTranslation = (WrappedComponent) => {
    class Translation extends Component {
        static propTypes = {
            label: PropTypes.string,
            placeholder: PropTypes.string,
            labelTextId: PropTypes.string,
            labelSubTextId: PropTypes.string,
            labelSubTextDefault: PropTypes.string,
            labelDefault: PropTypes.string,
            placeholderTextId: PropTypes.string,
            placeholderDefault: PropTypes.string,
            placeholderValuesToInject: PropTypes.object,
            intl: PropTypes.object
        };

        render() {
            const {
                label,
                placeholder,
                intl: { formatMessage },
                labelTextId,
                labelDefault,
                labelSubTextId,
                labelSubTextDefault,
                placeholderTextId,
                placeholderDefault,
                placeholderValuesToInject,
                ...rest
            } = this.props;
            let passThruLabel = label;
            if (labelTextId) {
                passThruLabel = formatMessage({
                    id: labelTextId,
                    defaultMessage: labelDefault || label
                });
            }

            let passThruPlaceholder = placeholder;

            if (placeholderTextId) {
                passThruPlaceholder = formatMessage(
                    {
                        id: placeholderTextId,
                        defaultMessage: placeholderDefault || placeholder
                    },
                    placeholderValuesToInject
                );
            }

            let passThruLabelSubText;

            if (labelSubTextId) {
                passThruLabelSubText = formatMessage({
                    id: labelSubTextId,
                    defaultMessage: labelSubTextDefault
                });
            }

            return (
                <WrappedComponent
                    label={passThruLabel}
                    placeholder={passThruPlaceholder}
                    labelSubText={passThruLabelSubText}
                    intl={this.props.intl}
                    {...rest}
                />
            );
        }
    }
    return injectIntl(Translation);
};

export default WithTranslation;
